/*
  Motor comum dos carrosseis do tema.

  O deslizar em si NAO esta aqui: o trilho e um scroller nativo com scroll-snap, entao
  o arraste com o dedo, a inercia e o encaixe sao do navegador. Este arquivo cuida da
  barra de progresso (inclusive arrastavel), das setas, do estado de fim de curso e do
  arraste com o mouse no computador - que o scroller nativo nao faz sozinho.

  Markup esperado (ver ui-carrossel.css):

    <div class="ui-carrossel" data-ui-carrossel>
      <ul class="ui-carrossel__trilho" data-ui-trilho> ... <li class="ui-carrossel__item">
      <div class="ui-carrossel__controles">
        <div class="ui-carrossel__trilha" data-ui-trilha><div class="ui-carrossel__fita" data-ui-fita>
        <button class="ui-carrossel__seta" data-ui-seta="-1|1">

  Se tudo couber na tela, o wrapper ganha .ui-carrossel--travado e os controles somem.
*/
(function () {
  'use strict';

  function iniciar(raiz) {
    var trilho = raiz.querySelector('[data-ui-trilho]');
    var trilha = raiz.querySelector('[data-ui-trilha]');
    var fita = raiz.querySelector('[data-ui-fita]');
    var setas = raiz.querySelectorAll('[data-ui-seta]');
    if (!trilho || !trilha || !fita) return;

    raiz.dataset.uiPronto = '1';

    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function sobra() {
      return trilho.scrollWidth - trilho.clientWidth;
    }

    function passo() {
      var item = trilho.querySelector('.ui-carrossel__item');
      if (!item) return trilho.clientWidth;
      var vao = parseFloat(getComputedStyle(trilho).columnGap) || 0;
      return item.getBoundingClientRect().width + vao;
    }

    function levarAte(x) {
      trilho.scrollTo({
        left: Math.min(sobra(), Math.max(0, x)),
        behavior: suave ? 'smooth' : 'auto'
      });
    }

    /*
      Leituras de layout primeiro, escritas depois: intercalar os dois forca o
      navegador a recalcular o layout no meio da funcao (reflow forcado de
      19-28ms medido no PSI). A leitura da trilha fica DEPOIS do toggle de
      proposito: quando o carrossel destrava, os controles acabaram de
      reaparecer e a largura so vale a partir dali (toggle sem mudanca de
      estado nao invalida nada, entao no caso comum essa leitura e gratis).
    */
    function pintar() {
      var scrollWidth = trilho.scrollWidth;
      var clientWidth = trilho.clientWidth;
      var scrollLeft = trilho.scrollLeft;
      var total = scrollWidth - clientWidth;
      var travado = total <= 1;
      raiz.classList.toggle('ui-carrossel--travado', travado);
      if (travado) return;

      var largura = trilha.clientWidth;
      var proporcao = clientWidth / scrollWidth;
      fita.style.width = Math.max(20, Math.round(proporcao * largura)) + 'px';
      fita.style.transform =
        'translateX(' + Math.round((scrollLeft / scrollWidth) * largura) + 'px)';

      for (var i = 0; i < setas.length; i++) {
        var dir = parseInt(setas[i].dataset.uiSeta, 10);
        setas[i].disabled = dir < 0 ? scrollLeft <= 1 : scrollLeft >= total - 1;
      }
    }

    /*
      O scroll dispara mais vezes por segundo do que a tela desenha; pintar
      mais de uma vez por quadro e trabalho jogado fora. A tela mostra no
      maximo 1 atualizacao por quadro de qualquer jeito.
    */
    var pinturaAgendada = false;
    function agendarPintura() {
      if (pinturaAgendada) return;
      pinturaAgendada = true;
      requestAnimationFrame(function () {
        pinturaAgendada = false;
        pintar();
      });
    }

    for (var i = 0; i < setas.length; i++) {
      setas[i].addEventListener('click', function () {
        levarAte(trilho.scrollLeft + parseInt(this.dataset.uiSeta, 10) * passo());
      });
    }

    /* ---------- arrastar a barra de progresso ---------- */

    var arrastando = false;

    function irPara(clienteX) {
      var caixa = trilha.getBoundingClientRect();
      var meio = fita.getBoundingClientRect().width / 2;
      var pos = (clienteX - caixa.left - meio) / Math.max(1, caixa.width - meio * 2);
      trilho.scrollLeft = Math.min(1, Math.max(0, pos)) * sobra();
    }

    trilha.addEventListener('pointerdown', function (e) {
      arrastando = true;
      trilho.style.scrollSnapType = 'none';
      trilha.setPointerCapture(e.pointerId);
      irPara(e.clientX);
    });

    trilha.addEventListener('pointermove', function (e) {
      if (arrastando) irPara(e.clientX);
    });

    function soltarBarra() {
      if (!arrastando) return;
      arrastando = false;
      trilho.style.scrollSnapType = '';
    }

    trilha.addEventListener('pointerup', soltarBarra);
    trilha.addEventListener('pointercancel', soltarBarra);

    /*
      ---------- arrastar o trilho com o mouse ----------
      O scroller nativo so responde ao dedo. O limiar de 5px e o mesmo da referencia:
      abaixo disso o gesto continua sendo um clique no item.
    */

    var origemX = 0;
    var origemScroll = 0;
    var puxando = false;
    var puxou = false;

    trilho.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      puxando = true;
      puxou = false;
      origemX = e.clientX;
      origemScroll = trilho.scrollLeft;
    });

    trilho.addEventListener('pointermove', function (e) {
      if (!puxando) return;
      var dx = e.clientX - origemX;
      if (!puxou) {
        if (Math.abs(dx) < 5) return;
        puxou = true;
        trilho.style.scrollSnapType = 'none';
        trilho.classList.add('ui-carrossel__trilho--puxando');
      }
      e.preventDefault();
      trilho.scrollLeft = origemScroll - dx;
    });

    /*
      Sem isto o navegador entende o gesto como "arrastar o link/a imagem pra outra
      janela" e para de mandar pointermove no meio do caminho.
    */
    trilho.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    function largar() {
      if (!puxando) return;
      puxando = false;
      trilho.classList.remove('ui-carrossel__trilho--puxando');
      if (!puxou) return;
      trilho.style.scrollSnapType = '';
      var largura = passo();
      levarAte(Math.round(trilho.scrollLeft / largura) * largura);
    }

    window.addEventListener('pointerup', largar);
    window.addEventListener('pointercancel', largar);

    trilho.addEventListener(
      'click',
      function (e) {
        if (puxou) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    trilho.addEventListener('scroll', agendarPintura, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(agendarPintura).observe(trilho);
    } else {
      window.addEventListener('resize', agendarPintura);
    }

    pintar();
  }

  function varrer(raiz) {
    var alvos = (raiz || document).querySelectorAll('[data-ui-carrossel]:not([data-ui-pronto])');
    for (var i = 0; i < alvos.length; i++) iniciar(alvos[i]);
  }

  /* carrossel que chega depois (fileiras da colecao trocadas por AJAX): inicia sozinho */
  new MutationObserver(function (ms) {
    for (var a = 0; a < ms.length; a++) {
      for (var b = 0; b < ms[a].addedNodes.length; b++) {
        var n = ms[a].addedNodes[b];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('[data-ui-carrossel]:not([data-ui-pronto])')) iniciar(n);
        varrer(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      varrer();
    });
  } else {
    varrer();
  }

  /* secao re-renderizada pelo editor de tema */
  document.addEventListener('shopify:section:load', function (e) {
    varrer(e.target);
  });
})();
